import { render, staticRenderFns } from "./Transiciones.vue?vue&type=template&id=4dbf9203&scoped=true"
import script from "./Transiciones.vue?vue&type=script&lang=js"
export * from "./Transiciones.vue?vue&type=script&lang=js"
import style0 from "./Transiciones.vue?vue&type=style&index=0&id=4dbf9203&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf9203",
  null
  
)

export default component.exports